import React, { useCallback } from 'react';
import { capitalize } from 'utils/capitalize';
import { analyticsUtils } from 'utils';
import { useOptimizedImages } from 'common/hooks/use-optimized-images';
import { StmLogo } from './stm-logo';
import { StmText } from './stm-text/stm-text';
import { StmSectionContainer } from './styles';
import { StmSectionProps } from './types';

export const StmSection: React.FC<StmSectionProps> = ({ stm }) => {
  const { label, logoLink, description, link } = stm;
  const capLabel = capitalize(label?.toLowerCase() || '');
  const capDescription = capitalize(description?.toLowerCase() || '');

  const gaCallback = useCallback(() => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'brandList', // блок, в котором расположен элемент
      elementName: 'Собственные торговые марки', // название блока (заголовок)
      elementText: capLabel, // название бренда
    });
  }, [capLabel]);
  const optimizedImage = useOptimizedImages(logoLink, {
    rest: {
      w: '150',
    },
  });
  return (
    <StmSectionContainer data-qa="stm-section" onClick={gaCallback}>
      <StmLogo
        img={optimizedImage.rest?.x || ''}
        imgRetina={`${optimizedImage.rest?.xx} 2x`}
        link={link}
        alt={label}
      />
      <StmText label={capLabel} description={capDescription} link={link} />
    </StmSectionContainer>
  );
};
